<template>
  <div class="store-list-container">
    <h2>门店列表</h2>
    <el-card shadow="hover">
      <div class="card-header">
        <el-input
          v-model="searchQuery"
          placeholder="搜索门店名称"
          style="width: 300px; margin-right: 10px;"
          clearable
          @input="handleSearch"
        >
          <template #prefix>
            <el-icon><Search /></el-icon>
          </template>
        </el-input>
        <el-button type="primary" @click="openCreateDrawer">
          <el-icon><Plus /></el-icon> 添加门店
        </el-button>
      </div>
      
      <el-table :data="stores" border stripe style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="门店名称" />
        <el-table-column prop="category.name" label="分类" width="100" />
        <el-table-column prop="address" label="地址" show-overflow-tooltip />
        <el-table-column prop="phone" label="电话" />
        <el-table-column prop="business_hours" label="营业时间" width="150" />
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag :type="scope.row.status ? 'success' : 'danger'">
              {{ scope.row.status ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="80" />
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="openEditDrawer(scope.row)">
              <el-icon><Edit /></el-icon> 编辑
            </el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row)">
              <el-icon><Delete /></el-icon> 删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="card-footer">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    
    <!-- 门店编辑/新增抽屉 -->
    <el-drawer
      v-model="drawerVisible"
      :title="isEdit ? '编辑门店' : '新增门店'"
      size="70%"
      direction="rtl"
      :before-close="handleDrawerClose"
    >
      <el-form ref="formRef" :model="storeForm" :rules="rules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="门店名称" prop="name">
              <el-input v-model="storeForm.name" placeholder="请输入门店名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="门店分类" prop="category_id">
              <el-select v-model="storeForm.category_id" placeholder="请选择门店分类">
                <el-option
                  v-for="category in categories"
                  :key="category.id"
                  :label="category.name"
                  :value="category.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="storeForm.phone" placeholder="请输入联系电话" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="storeForm.email" placeholder="请输入电子邮箱" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="营业时间" prop="business_hours">
              <el-input v-model="storeForm.business_hours" placeholder="请输入营业时间，如：09:00-21:00" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort_order">
              <el-input-number v-model="storeForm.sort_order" :min="0" :max="999" placeholder="请输入排序号" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="门店地址" prop="address">
              <div style="display: flex; gap: 10px; margin-bottom: 10px;">
                <el-select v-model="storeForm.province" placeholder="请选择省份" style="width: 150px;">
                  <el-option
                    v-for="province in provinces"
                    :key="province.id"
                    :label="province.name"
                    :value="province.name"
                  />
                </el-select>
                <el-select v-model="storeForm.city" placeholder="请选择城市" style="width: 150px;">
                  <el-option
                    v-for="city in cities"
                    :key="city.id"
                    :label="city.name"
                    :value="city.name"
                  />
                </el-select>
                <el-select v-model="storeForm.district" placeholder="请选择区县" style="width: 150px;">
                  <el-option
                    v-for="district in districts"
                    :key="district.id"
                    :label="district.name"
                    :value="district.name"
                  />
                </el-select>
              </div>
              <div style="display: flex;">
                <el-input v-model="storeForm.address" placeholder="请输入详细地址" style="flex: 1; margin-right: 10px;" />
                <el-button type="primary" @click="searchAddress">
                  <el-icon><Search /></el-icon> 搜索
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="地图位置">
              <div class="map-container">
                <div id="store-map" style="width: 100%; height: 400px;"></div>
                <div class="map-tip">点击地图选择位置，或在地址框输入地址后点击搜索</div>
              </div>
              <div class="coordinates-info" v-if="storeForm.latitude && storeForm.longitude">
                <span>当前坐标：</span>
                <span>{{ storeForm.latitude }}, {{ storeForm.longitude }}</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="storeForm.latitude" placeholder="请输入纬度" type="number" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经度" prop="longitude">
              <el-input v-model="storeForm.longitude" placeholder="请输入经度" type="number" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="门店描述" prop="description">
              <el-input v-model="storeForm.description" type="textarea" placeholder="请输入门店描述" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="门店Logo" prop="logo">
              <el-input v-model="storeForm.logo" placeholder="请输入门店Logo URL" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-switch v-model="storeForm.status" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
          <el-button @click="handleDrawerClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { ref, reactive, onMounted, watch } from 'vue';
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import { Search, Plus, Edit, Delete } from '@element-plus/icons-vue';
import service from '../../api/axios';

export default {
  name: 'StoreList',
  components: {
    Search,
    Plus,
    Edit,
    Delete
  },
  setup() {
    // 列表数据
    const stores = ref([]);
    const loading = ref(false);
    const searchQuery = ref('');
    const currentPage = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    
    // 抽屉相关
    const drawerVisible = ref(false);
    const isEdit = ref(false);
    const formRef = ref(null);
    const categories = ref([]);
    
    // 省市区数据
    const provinces = ref([]);
    const cities = ref([]);
    const districts = ref([]);
    
    // 表单数据
    const storeForm = reactive({
      name: '',
      category_id: '',
      phone: '',
      email: '',
      province: '',
      city: '',
      district: '',
      address: '',
      logo: '',
      description: '',
      business_hours: '',
      status: true,
      sort_order: 0,
      latitude: '',
      longitude: ''
    });
    
    // 表单验证规则
    const rules = {
      name: [
        { required: true, message: '请输入门店名称', trigger: 'blur' },
        { max: 100, message: '门店名称不能超过100个字符', trigger: 'blur' }
      ],
      category_id: [
        { required: true, message: '请选择门店分类', trigger: 'change' }
      ],
      phone: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        { max: 20, message: '联系电话不能超过20个字符', trigger: 'blur' }
      ],
      address: [
        { required: true, message: '请输入门店地址', trigger: 'blur' },
        { max: 255, message: '门店地址不能超过255个字符', trigger: 'blur' }
      ]
    };
    
    // 获取门店列表
    const fetchStores = async () => {
      loading.value = true;
      try {
        const response = await service({
          url: '/manage/stores',
          method: 'get',
          params: {
            keyword: searchQuery.value,
            page: currentPage.value,
            pageSize: pageSize.value
          }
        });
        stores.value = response.data.data;
        total.value = response.data.total;
      } catch (error) {
        ElMessage.error('获取门店列表失败');
        console.error(error);
        stores.value = [];
        total.value = 0;
      } finally {
        loading.value = false;
      }
    };
    
    // 获取门店分类列表
    const fetchCategories = async () => {
      try {
        const response = await service({
          url: '/manage/store-categories',
          method: 'get'
        });
        categories.value = response.data.data;
      } catch (error) {
        ElMessage.error('获取门店分类失败');
        console.error(error);
      }
    };
    
    // 获取省份列表
    const fetchProvinces = async () => {
      try {
        const response = await service({
          url: '/manage/provinces',
          method: 'get'
        });
        provinces.value = response.data;
      } catch (error) {
        ElMessage.error('获取省份列表失败');
        console.error(error);
        // 如果接口调用失败，使用默认数据
        provinces.value = [{ id: 1, name: '广东省' }, { id: 2, name: '北京市' }, { id: 3, name: '上海市' }];
      }
    };
    
    // 获取城市列表
    const fetchCities = async (provinceId) => {
      try {
        const response = await service({
          url: '/manage/cities',
          method: 'get',
          params: { province_id: provinceId }
        });
        cities.value = response.data;
      } catch (error) {
        ElMessage.error('获取城市列表失败');
        console.error(error);
        // 如果接口调用失败，使用默认数据
        cities.value = [{ id: 1, name: '广州市' }, { id: 2, name: '深圳市' }];
      }
    };
    
    // 获取区县列表
    const fetchDistricts = async (cityId) => {
      try {
        const response = await service({
          url: '/manage/districts',
          method: 'get',
          params: { city_id: cityId }
        });
        districts.value = response.data;
      } catch (error) {
        ElMessage.error('获取区县列表失败');
        console.error(error);
        // 如果接口调用失败，使用默认数据
        districts.value = [{ id: 1, name: '天河区' }, { id: 2, name: '越秀区' }];
      }
    };
    
    // 页面加载时获取数据
    onMounted(() => {
      fetchStores();
      fetchCategories();
      fetchProvinces();
    });
    
    // 监听省份变化，更新城市列表
    watch(() => storeForm.province, (newProvince) => {
      if (newProvince) {
        // 重置城市和区县
        storeForm.city = '';
        storeForm.district = '';
        cities.value = [];
        districts.value = [];
        
        // 获取对应的省份ID
        const province = provinces.value.find(p => p.name === newProvince);
        if (province) {
          fetchCities(province.id);
        }
      } else {
        cities.value = [];
        districts.value = [];
      }
    });
    
    // 监听城市变化，更新区县列表
    watch(() => storeForm.city, (newCity) => {
      if (newCity) {
        // 重置区县
        storeForm.district = '';
        districts.value = [];
        
        // 获取对应的城市ID
        const city = cities.value.find(c => c.name === newCity);
        if (city) {
          fetchDistricts(city.id);
        }
      } else {
        districts.value = [];
      }
    });
    
    // 搜索门店
    const handleSearch = () => {
      fetchStores();
    };
    
    // 打开新增抽屉
    const openCreateDrawer = () => {
      isEdit.value = false;
      // 重置表单
      if (formRef.value) {
        formRef.value.resetFields();
      }
      // 重置表单数据
      Object.assign(storeForm, {
        name: '',
        category_id: '',
        phone: '',
        email: '',
        province: '',
        city: '',
        district: '',
        address: '',
        logo: '',
        description: '',
        business_hours: '',
        status: true,
        sort_order: 0,
        latitude: '',
        longitude: ''
      });
      drawerVisible.value = true;
    };
    
    // 搜索地址函数
    const searchAddress = () => {
      // 组合完整地址：省 + 市 + 区 + 详细地址，各部分间添加空格
      const addressParts = [];
      if (storeForm.province) addressParts.push(storeForm.province);
      if (storeForm.city) addressParts.push(storeForm.city);
      if (storeForm.district) addressParts.push(storeForm.district);
      if (storeForm.address) addressParts.push(storeForm.address);
      const fullAddress = addressParts.join(' ');
      
      if (!fullAddress) {
        ElMessage.warning('请输入完整地址');
        return;
      }
      
      getCoordinatesFromAddress(fullAddress);
    };
    
    // 地图相关
    let map = null;
    let marker = null;
    
    // 初始化地图
    const initMap = () => {
      // 确保地图容器存在
      const mapContainer = document.getElementById('store-map');
      if (!mapContainer) {
        console.error('地图容器不存在');
        ElMessage.error('地图容器不存在');
        return false;
      }
      
      // 检查容器尺寸是否有效
      const containerRect = mapContainer.getBoundingClientRect();
      if (containerRect.width === 0 || containerRect.height === 0) {
        console.error('地图容器尺寸无效');
        ElMessage.error('地图容器尺寸无效');
        return false;
      }
      
      console.log('开始初始化地图，容器尺寸:', containerRect.width, 'x', containerRect.height);
      
      // 动态加载TMap库
      if (!window.TMap) {
        console.log('开始加载TMap库...');
        ElMessage.info('正在加载地图服务...');
        
        // 创建script标签加载地图API
        const script = document.createElement('script');
        script.src = `https://map.qq.com/api/gljs?v=1.exp&key=B3DBZ-AF5WZ-QEJX3-7CJ2A-BBCNT-OHFFR&libraries=service`;
        script.onload = () => {
          console.log('TMap库加载成功');
          initMapInstance(mapContainer);
        };
        script.onerror = (error) => {
          console.error('TMap库加载失败:', error);
          ElMessage.error('地图服务加载失败，请刷新页面重试');
        };
        document.head.appendChild(script);
        return false; // 异步加载，返回false表示还未完成
      } else {
        // TMap已加载，直接初始化地图实例
        return initMapInstance(mapContainer);
      }
    };
    
    // 初始化地图实例
    const initMapInstance = (mapContainer) => {
      try {
        // 确保TMap已加载
        if (!window.TMap) {
          console.error('TMap未加载');
          ElMessage.error('地图服务未加载，请刷新页面重试');
          return false;
        }
        
        // 创建地图实例
        map = new window.TMap.Map(mapContainer, {
          center: new window.TMap.LatLng(storeForm.latitude || 23.1291, storeForm.longitude || 113.2644), // 默认广州
          zoom: 15,
          mapStyleId: 'style1' // 使用默认样式
        });
        
        console.log('地图实例创建成功');
        
        // 创建标记
        marker = new window.TMap.MultiMarker({
          map: map,
          styles: {
            'marker': new window.TMap.MarkerStyle({
              'width': 25,
              'height': 35,
              'anchor': {
                'x': 12,
                'y': 35
              },
              'src': 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker.png'
            })
          },
          geometries: storeForm.latitude && storeForm.longitude ? [{
            'id': '1',
            'styleId': 'marker',
            'position': new window.TMap.LatLng(storeForm.latitude, storeForm.longitude)
          }] : []
        });
        
        console.log('地图标记创建成功');
        
        // 监听地图点击事件
        map.on('click', (evt) => {
          const latLng = evt.latLng;
          console.log('地图点击事件:', latLng.getLat(), latLng.getLng());
          // 调用更新函数，由该函数处理坐标和地址更新
          updateMarkerAndCoordinates(latLng);
        });
        
        return true;
      } catch (error) {
        console.error('地图初始化失败:', error);
        ElMessage.error('地图初始化失败，请刷新页面重试');
        return false;
      }
    };
    
    // 从坐标获取地址
    const getAddressFromCoordinates = (latLng) => {
      // 显示加载状态
      const loadingInstance = ElLoading.service({ 
        lock: false, 
        text: '正在获取地址...',
        background: 'rgba(255, 255, 255, 0.7)' 
      });
      
      // 使用async/await确保TMap和地理编码服务完全加载
      const fetchAddress = async () => {
        try {
          // 确保TMap已加载
          await ensureTMapLoaded();
          
          // 验证TMap和地理编码服务是否可用
          if (!window.TMap || !window.TMap.service || !window.TMap.service.Geocoder) {
            throw new Error('TMap或地理编码服务未加载');
          }
          
          const geocoder = new window.TMap.service.Geocoder({
            key: 'B3DBZ-AF5WZ-QEJX3-7CJ2A-BBCNT-OHFFR' // 显式传入密钥
          });
          
          console.log('开始逆地址解析:', latLng.getLat(), latLng.getLng());
          
          // 检查逆地理编码方法是否存在，并使用正确的方法名
          let reverseGeocodeMethod = null;
          if (typeof geocoder.reverseGeocoder === 'function') {
            reverseGeocodeMethod = geocoder.reverseGeocoder;
            console.log('使用reverseGeocoder方法');
          } else if (typeof geocoder.reverseGeocode === 'function') {
            reverseGeocodeMethod = geocoder.reverseGeocode;
            console.log('使用reverseGeocode方法');
          } else if (typeof geocoder.getAddress === 'function') {
            reverseGeocodeMethod = geocoder.getAddress;
            console.log('使用getAddress方法');
          } else {
            throw new Error('找不到逆地理编码方法');
          }
          
          // 使用回调方式调用地理编码服务
          reverseGeocodeMethod.call(geocoder, {
            location: latLng
          }).then(result => {
            console.log('逆地址解析结果:', result);
            
            if (result.status === 0) {
              const addressResult = result.result;
              // 更新详细地址
              storeForm.address = addressResult.address;
              
              // 尝试解析省市区
              const addressComponent = addressResult.address_component;
              if (addressComponent) {
                // 更新省份
                if (addressComponent.province && addressComponent.province !== storeForm.province) {
                  storeForm.province = addressComponent.province;
                  // 重置城市和区县，等待watch触发更新
                  storeForm.city = '';
                  storeForm.district = '';
                }
                // 更新城市
                if (addressComponent.city && addressComponent.city !== storeForm.city) {
                  storeForm.city = addressComponent.city;
                  // 重置区县，等待watch触发更新
                  storeForm.district = '';
                }
                // 更新区县
                if (addressComponent.district && addressComponent.district !== storeForm.district) {
                  storeForm.district = addressComponent.district;
                }
              }
              ElMessage.success('地址获取成功');
            } else {
              let errorMessage = '逆地址解析失败';
              switch(result.status) {
                case 1: errorMessage += '：请求参数非法'; break;
                case 2: errorMessage += '：API密钥无效'; break;
                case 3: errorMessage += '：服务不可用'; break;
                case 4: errorMessage += '：请求次数超限（每日调用量已达到上限）'; break;
                case 5: errorMessage += '：无结果'; break;
                default: errorMessage += '：' + (result.message || '未知错误');
              }
              console.error(errorMessage);
              ElMessage.error(errorMessage);
            }
          }).catch(error => {
            console.error('逆地址解析异常:', error);
            ElMessage.error('获取地址失败: ' + error.message);
          }).finally(() => {
            loadingInstance.close();
          });
        } catch (error) {
          console.error('逆地址解析异常:', error);
          ElMessage.error('获取地址失败: ' + error.message);
          loadingInstance.close();
        }
      };
      
      fetchAddress();
    };
    
    // TMap加载状态管理
    const tMapLoaded = ref(false);
    const tMapLoading = ref(false);
    
    // 统一的TMap加载函数
    const ensureTMapLoaded = () => {
      return new Promise((resolve, reject) => {
        // 如果已加载，直接返回
        if (tMapLoaded.value) {
          resolve();
          return;
        }
        
        // 如果正在加载，等待加载完成
        if (tMapLoading.value) {
          const checkLoaded = () => {
            if (tMapLoaded.value) {
              resolve();
            } else {
              setTimeout(checkLoaded, 100);
            }
          };
          checkLoaded();
          return;
        }
        
        // 开始加载
        tMapLoading.value = true;
        
        // 创建script标签加载地图API，包含service库
        const script = document.createElement('script');
        script.src = `https://map.qq.com/api/gljs?v=1.exp&key=B3DBZ-AF5WZ-QEJX3-7CJ2A-BBCNT-OHFFR&libraries=service`;
        script.onload = () => {
          console.log('TMap库加载成功');
          tMapLoaded.value = true;
          tMapLoading.value = false;
          resolve();
        };
        script.onerror = (error) => {
          console.error('TMap库加载失败:', error);
          tMapLoading.value = false;
          reject(error);
        };
        document.head.appendChild(script);
      });
    };
    
    // 从地址获取坐标
    const getCoordinatesFromAddress = (address) => {
      if (!address) {
        ElMessage.warning('请输入完整地址');
        return;
      }
      
      // 显示加载状态
      const loadingInstance = ElLoading.service({ 
        lock: false, 
        text: '正在解析地址...',
        background: 'rgba(255, 255, 255, 0.7)' 
      });
      
      // 使用async/await确保TMap和地理编码服务完全加载
      const fetchCoordinates = async () => {
        try {
          // 确保TMap已加载
          await ensureTMapLoaded();
          
          // 验证TMap和地理编码服务是否可用
          if (!window.TMap || !window.TMap.service || !window.TMap.service.Geocoder) {
            throw new Error('TMap或地理编码服务未加载');
          }
          
          // 确保地图实例已创建
          if (!map) {
            // 初始化地图
            const success = initMap();
            if (!success) {
              // 如果initMap返回false，表示需要等待异步加载
              await new Promise(resolve => setTimeout(resolve, 1000));
            }
          }
          
          console.log('开始地址解析:', address, 'region:', storeForm.province);
          
          // 创建地理编码实例
          const geocoder = new window.TMap.service.Geocoder({
            key: 'B3DBZ-AF5WZ-QEJX3-7CJ2A-BBCNT-OHFFR' // 显式传入密钥
          });
          
          // 使用Promise回调方式调用地理编码服务，避免方法名错误
          geocoder.getLocation({
            address: address,
            region: storeForm.province || ''
          }).then(result => {
            console.log('地址解析结果:', result);
            
            if (result.status === 0) {
              const latLng = result.result.location;
              updateMarkerAndCoordinates(latLng, false);
              // 更新地图中心和缩放级别
              if (map) {
                map.setCenter(latLng);
                map.setZoom(15);
              }
              ElMessage.success('地址解析成功');
            } else {
              let errorMessage = '地址解析失败';
              switch(result.status) {
                case 1: 
                  errorMessage += '：请求参数非法'; 
                  console.error('请求参数非法:', address);
                  break;
                case 2: 
                  errorMessage += '：API密钥无效或未开通地理编码服务'; 
                  console.error('API密钥问题');
                  break;
                case 3: 
                  errorMessage += '：地理编码服务不可用'; 
                  console.error('服务不可用');
                  break;
                case 4: 
                  errorMessage += '：请求次数超限（每日调用量已达到上限）'; 
                  console.error('请求次数超限（每日调用量已达到上限）');
                  break;
                case 5: 
                  errorMessage += '：未找到匹配地址，请尝试更详细的地址'; 
                  console.error('未找到地址:', address);
                  break;
                default: 
                  errorMessage += '：' + (result.message || '未知错误');
                  console.error('未知错误:', result);
              }
              ElMessage.error(errorMessage);
            }
          }).catch(error => {
            console.error('地址解析异常:', error);
            
            // 详细的错误处理
            if (error.message) {
              if (error.message.includes('NetworkError') || error.message.includes('Failed to fetch')) {
                ElMessage.error('网络连接失败，请检查网络设置后重试');
              } else if (error.message.includes('timeout')) {
                ElMessage.error('请求超时，请稍后重试');
              } else if (error.message.includes('invalid') || error.message.includes('key')) {
                ElMessage.error('API密钥无效，请联系管理员');
              } else {
                ElMessage.error('地址解析失败: ' + error.message);
              }
            } else {
              ElMessage.error('地址解析失败，请稍后重试或手动输入坐标');
            }
            
            // 添加手动输入坐标的提示
            ElMessage({ 
              type: 'info', 
              message: '您也可以直接在地图上点击选择位置', 
              duration: 3000 
            });
          }).finally(() => {
            loadingInstance.close();
          });
        } catch (error) {
          console.error('地址解析异常:', error);
          
          // 详细的错误处理
          if (error.message) {
            if (error.message.includes('NetworkError') || error.message.includes('Failed to fetch')) {
              ElMessage.error('网络连接失败，请检查网络设置后重试');
            } else if (error.message.includes('timeout')) {
              ElMessage.error('请求超时，请稍后重试');
            } else if (error.message.includes('invalid') || error.message.includes('key')) {
              ElMessage.error('API密钥无效，请联系管理员');
            } else {
              ElMessage.error('地址解析失败: ' + error.message);
            }
          } else {
            ElMessage.error('地址解析失败，请稍后重试或手动输入坐标');
          }
          
          // 添加手动输入坐标的提示
          ElMessage({ 
            type: 'info', 
            message: '您也可以直接在地图上点击选择位置', 
            duration: 3000 
          });
          
          loadingInstance.close();
        }
      };
      
      fetchCoordinates();
    };
    
    // 更新标记和坐标（添加skipAddressUpdate参数避免循环更新）
    const updateMarkerAndCoordinates = (latLng, skipAddressUpdate = false) => {
      // 更新表单坐标
      const newLat = latLng.getLat().toFixed(6);
      const newLng = latLng.getLng().toFixed(6);
      
      // 只有当坐标发生变化时才更新
      if (storeForm.latitude !== newLat || storeForm.longitude !== newLng) {
        storeForm.latitude = newLat;
        storeForm.longitude = newLng;
        
        // 更新标记位置
        if (marker) {
          marker.setGeometries([{
            'id': '1',
            'styleId': 'marker',
            'position': latLng
          }]);
        }
        
        // 将地图中心移到点击位置，确保标记可见
        if (map) {
          map.setCenter(latLng);
        }
        
        // 逆地址解析（如果不需要跳过）
        if (!skipAddressUpdate) {
          getAddressFromCoordinates(latLng);
        }
      }
    };
    
    // 监听经纬度变化
    watch([() => storeForm.latitude, () => storeForm.longitude], ([newLat, newLng], [oldLat, oldLng]) => {
      // 只有当经纬度发生实际变化且都不为空时才触发
      if (newLat && newLng && (newLat !== oldLat || newLng !== oldLng)) {
        try {
          const latLng = new window.TMap.LatLng(parseFloat(newLat), parseFloat(newLng));
          
          // 更新地图标记和中心
          if (marker) {
            marker.setGeometries([{
              'id': '1',
              'styleId': 'marker',
              'position': latLng
            }]);
          }
          if (map) {
            map.setCenter(latLng);
          }
          
          // 逆地址解析获取地址
          getAddressFromCoordinates(latLng);
        } catch (error) {
          console.error('经纬度格式错误:', error);
        }
      }
    });
    
    // 监听抽屉可见性变化
    watch(drawerVisible, (newVal) => {
      if (newVal) {
        // 延迟初始化地图，确保DOM已渲染
        setTimeout(() => {
          initMap();
        }, 100);
      } else {
        // 抽屉关闭时，重置地图实例，避免下次打开时出现问题
        map = null;
        marker = null;
      }
    });
    
    // 打开编辑抽屉
    const openEditDrawer = async (store) => {
      isEdit.value = true;
      drawerVisible.value = true;
      
      try {
        const response = await service({
          url: `/manage/stores/${store.id}`,
          method: 'get'
        });
        
        // 将获取到的数据赋值给表单
        const storeData = response.data.data;
        for (const key in storeForm) {
          if (Object.prototype.hasOwnProperty.call(storeData, key)) {
            storeForm[key] = storeData[key];
          }
        }
        
        // 延迟更新地图标记，确保地图已初始化
        setTimeout(() => {
          if (storeForm.latitude && storeForm.longitude && map && marker) {
            const latLng = new window.TMap.LatLng(storeForm.latitude, storeForm.longitude);
            map.setCenter(latLng);
            marker.setGeometries([{
              'id': '1',
              'styleId': 'marker',
              'position': latLng
            }]);
          }
        }, 200);
      } catch (error) {
        ElMessage.error('获取门店详情失败');
        console.error(error);
        drawerVisible.value = false;
      }
    };
    
    // 关闭抽屉
    const handleDrawerClose = () => {
      drawerVisible.value = false;
    };
    
    // 提交表单
    const handleSubmit = async () => {
      if (!formRef.value) return;
      
      await formRef.value.validate(async (valid) => {
        if (valid) {
          try {
            let response;
            if (isEdit.value) {
              // 编辑门店
              response = await service({
                url: `/manage/stores/${storeForm.id}`,
                method: 'put',
                data: storeForm
              });
            } else {
              // 新增门店
              response = await service({
                url: '/manage/stores',
                method: 'post',
                data: storeForm
              });
            }
            
            ElMessage.success(response.data.message || (isEdit.value ? '编辑成功' : '新增成功'));
            drawerVisible.value = false;
            fetchStores();
          } catch (error) {
            ElMessage.error(error.response?.data?.message || (isEdit.value ? '编辑失败' : '新增失败'));
            console.error(error);
          }
        }
      });
    };
    
    // 删除门店
    const handleDelete = (store) => {
      ElMessageBox.confirm('确定要删除该门店吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await service({
            url: `/manage/stores/${store.id}`,
            method: 'delete'
          });
          ElMessage.success('删除成功');
          fetchStores();
        } catch (error) {
          ElMessage.error('删除失败');
          console.error(error);
        }
      }).catch(() => {
        // 取消删除操作
      });
    };
    
    // 处理分页大小变化
    const handleSizeChange = (size) => {
      pageSize.value = size;
      fetchStores();
    };
    
    // 处理当前页变化
    const handleCurrentChange = (current) => {
      currentPage.value = current;
      fetchStores();
    };
    
    return {
      // 列表数据
      stores,
      loading,
      searchQuery,
      currentPage,
      pageSize,
      total,
      handleSearch,
      handleDelete,
      handleSizeChange,
      handleCurrentChange,
      // 抽屉相关
      drawerVisible,
      isEdit,
      formRef,
      storeForm,
      rules,
      categories,
      openCreateDrawer,
      openEditDrawer,
      handleDrawerClose,
      handleSubmit,
      // 省市区数据
      provinces,
      cities,
      districts,
      // 地图相关
      getCoordinatesFromAddress,
      searchAddress
    };
  }
};
</script>

<style scoped>
.store-list-container {
  padding: 20px;
}

.store-list-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-footer {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 地图相关样式 */
.map-container {
  position: relative;
}

#store-map {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.map-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}

.coordinates-info {
  margin-top: 12px;
  font-size: 14px;
  color: #606266;
  background-color: #f5f7fa;
  padding: 8px 12px;
  border-radius: 4px;
  display: inline-block;
}
</style>